import { Box, Typography } from "@mui/material";
import { colors } from "../ui/colors";
import { CompanyAvatar } from "./CompanyAvatar";

export const CompanySwitchSnackbarContent = ({ company }) => {
  const companyName = company?.businessName || company?.name || "your company";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
      <CompanyAvatar company={company} size={34} />
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            color: colors.orange.base,
            fontSize: 14,
            fontWeight: 900,
            lineHeight: 1.2,
          }}
          noWrap
        >
          Switched to company{" "}
          <Box component="span" sx={{ color: colors.gray.base, fontWeight: 950 }}>
            {companyName}.
          </Box>
        </Typography>
        <Typography
          sx={{
            color: colors.gray[400],
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.35,
          }}
          noWrap
        >
          Welcome to your dashboard.
        </Typography>
      </Box>
    </Box>
  );
};
